/* eslint-disable no-restricted-globals */
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { exportAgenciesSimpleToSimpleSelectData } from 'src/adapters';
import { SelectSimple } from 'src/components/selects/SelectSimple';
import { currentPosAgencySelector, setCurrentPosAgency } from 'src/features/pos/store';
import { useAgencies } from 'src/hooks/useAgencies';

type Props = {
  testID?: string;
};

export const PosAgencySelector: React.FC<Props> = ({ testID = 'PosAgencySelector' }) => {
  const { t } = useTranslation();
  const currentAgency = useSelector(currentPosAgencySelector);
  const { scopedAgenciesWithoutPartners: organizationAgencies } = useAgencies();

  const selectedAgency = useMemo(() => {
    if (currentAgency && organizationAgencies) {
      return organizationAgencies.find((agency) => agency.id === currentAgency);
    }
  }, [organizationAgencies, currentAgency]);

  const dispatch = useDispatch();

  const selectData = useMemo(() => {
    if (!organizationAgencies) {
      return [];
    }

    return exportAgenciesSimpleToSimpleSelectData(organizationAgencies ?? []);
  }, [organizationAgencies]);

  const onAgencySelect = useCallback(
    (value) => {
      const agencyId = value;
      const isConfirmed = confirm(t('pos.confirm-agency'));

      if (isConfirmed) {
        dispatch(setCurrentPosAgency({ currentAgency: agencyId }));
      }
    },
    [t, dispatch],
  );

  return (
    <div data-testid={testID} className="pt-10">
      <SelectSimple
        selectedId={selectedAgency?.id}
        data={selectData}
        placeholder="pos.select-pos-agency"
        onChange={onAgencySelect}
      />
    </div>
  );
};
